import axios from 'axios';

export default {
  getProductById,
  getProductByCode,
  getProductByUrlKey,
  getProductsByType,
  getAverageReviewsByProductId
};

export function getProductById(params) {
  return axios.get('/api/product/getProductById', { params });
}

export function getProductByCode(params) {
  return axios.get('/api/product/getProductByCode', { params });
}

export function getProductByUrlKey(params) {
  return axios.get('/api/product/getProductByUrlKey', { params });
}

export function getProductsById(params) {
  return axios.get('/api/product/getProductsById', { params });
}

export function getProductsByType(params) {
  return axios.get('/api/product/getProductsByType', { params });
}

export function getAverageReviewsByProductId(params) {
  return axios.get('/api/product/getAverageReviewsByProductId', { params });
}
